'use strict';

var _values = require('babel-runtime/core-js/object/values');

var _values2 = _interopRequireDefault(_values);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = function (config) {
  config.app.head.script = [{
    src: 'https://cdn.ravenjs.com/3.10.0/raven.min.js',
    crossOrigin: 'anonymous'
  }];

  config.app.prometheusStores.eukdlx.askSid = {
    enabled: true,
    src: 'https://staging-api.asksid.ai/akzo-webchat/wc.min.js'
  };

  config.app.prometheusStores.enlflx.askSid = {
    enabled: true,
    src: 'https://staging-api.asksid.ai/akzo-webchat-enlflx/wc.min.js'
  };

  config.app.prometheusStores.enlwdm.askSid = {
    enabled: true,
    src: 'https://staging-api.asksid.ai/akzo-webchat-enlwdm/wc.min.js'
  };

  config.app.prometheusStores.ebelev.askSid = {
    enabled: true,
    src: 'https://staging-api.asksid.ai/akzo-webchat-ebelev/wc.min.js'
  };

  config.app.prometheusStores.enlwdc.askSid = {
    enabled: true,
    src: 'https://staging-api.asksid.ai/akzo-webchat-enlwdc/wc.min.js'
  };

  config.app.prometheusStores.efrdxv.askSid = {
    enabled: true,
    src: 'https://staging-api.asksid.ai/akzo-webchat-efrdxv/wc.min.js'
  };
  config.app.prometheusStores.eukdlx.pickupLocations = { enabled: true };

  (0, _values2.default)(config.app.prometheusStores).forEach(function (store) {
    store.tagManager = {
      type: 'gtm',
      containerId: 'GTM-M2B63V9G'
    };
  });

  config.app.prometheusStores.enlflx.oneTrustConsentDomainScript = '0898b53b-f85e-4670-a13f-31d7de9f4930-test';

  config.app.prometheusStores.enlwdm.oneTrustConsentDomainScript = '0898b53b-f85e-4670-a13f-31d7de9f4930-test';

  var stagingLaunchEmbedCode = '//assets.adobedtm.com/feb986e74bf7/f95cb7da5d29/launch-e901e932f83f-staging.min.js';
  (0, _values2.default)(config.app.prometheusStores).forEach(function (store) {
    if (store.tagManager && store.tagManager.type === 'launch') {
      store.tagManager.launchEmbedCode = stagingLaunchEmbedCode;
    }
  });
  config.oneTrustConsentEmbedCode = '//cdn.cookielaw.org/scripttemplates/otSDKStub.js';

  return config;
};


//////////////////
// WEBPACK FOOTER
// ./config/staging/index.js
// module id = 2424
// module chunks = 0